export default "__VITE_ASSET__CxtLcf$n__"